/* tslint:disable */
/* eslint-disable */
/**
 * Melco Identity APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IdentityMelcoModelsUserDiscount
 */
export interface IdentityMelcoModelsUserDiscount {
    /**
     * 
     * @type {string}
     * @memberof IdentityMelcoModelsUserDiscount
     */
    code?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IdentityMelcoModelsUserDiscount
     */
    product_code?: string | null;
    /**
     * 
     * @type {number}
     * @memberof IdentityMelcoModelsUserDiscount
     */
    amount?: number;
}

export function IdentityMelcoModelsUserDiscountFromJSON(json: any): IdentityMelcoModelsUserDiscount {
    return IdentityMelcoModelsUserDiscountFromJSONTyped(json, false);
}

export function IdentityMelcoModelsUserDiscountFromJSONTyped(json: any, ignoreDiscriminator: boolean): IdentityMelcoModelsUserDiscount {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'code': !exists(json, 'code') ? undefined : json['code'],
        'product_code': !exists(json, 'product_code') ? undefined : json['product_code'],
        'amount': !exists(json, 'amount') ? undefined : json['amount'],
    };
}

export function IdentityMelcoModelsUserDiscountToJSON(value?: IdentityMelcoModelsUserDiscount | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'code': value.code,
        'product_code': value.product_code,
        'amount': value.amount,
    };
}


